const ADD_MODE = {
    LIST: 'list',
    DEFAULT: 'add',
    APPLICATIONS: 'applications',
    PAYMENTS: 'payments',
    LEASES: 'leases',
};

const AddPropertyConstants = {
    ADD_MODE,
};

export default AddPropertyConstants;
